import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=049badd8&scoped=true&"
import script from "./Simple.vue?vue&type=script&lang=js&"
export * from "./Simple.vue?vue&type=script&lang=js&"
import style0 from "./Simple.vue?vue&type=style&index=0&id=049badd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049badd8",
  null
  
)

export default component.exports